import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchPlatformHealthIssuesArgs,
  FetchPlatformDemographicsArgs,
  FetchPlatformEngagementArgs,
} from '../api/types/statsInsights.types';

import {
  fetchPlatformHealthIssues,
  fetchPlatformDemographics,
  fetchPremiumHealthIssues,
  fetchPremiumDemographics,
  fetchPlatformTenantOrganizations,
  fetchPlatformEngagement,
  fetchPlatformTenants,
} from '../api/platformStats.api';

export const statsPlatformQueryKeys = createQueryKeys('statsPlatform', {
  fetchDemographics: (args: FetchPlatformDemographicsArgs) => ({
    queryFn: () => fetchPlatformDemographics(args),
    queryKey: [args],
  }),
  fetchEngagement: (args: FetchPlatformEngagementArgs) => ({
    queryFn: () => fetchPlatformEngagement(args),
    queryKey: [args],
  }),
  fetchHealthIssues: (args: FetchPlatformHealthIssuesArgs = {}) => ({
    queryFn: () => fetchPlatformHealthIssues(args),
    queryKey: [args],
  }),
  fetchPremiumDemographics: (
    organizationId: string,
    args: FetchPlatformDemographicsArgs,
  ) => ({
    queryFn: () => fetchPremiumDemographics(organizationId, args),
    queryKey: [organizationId, args],
  }),
  fetchPremiumHealthIssues: (
    organizationId: string,
    args: FetchPlatformHealthIssuesArgs = {},
  ) => ({
    queryFn: () => fetchPremiumHealthIssues(organizationId, args),
    queryKey: [organizationId, args],
  }),
  fetchTenantOrganizations: (tenantId: string) => ({
    queryFn: () => fetchPlatformTenantOrganizations(tenantId),
    queryKey: [tenantId],
  }),
  fetchTenants: {
    queryFn: () => fetchPlatformTenants(),
    queryKey: null,
  },
});
